import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=50fc15b5&scoped=true&"
import script from "./FormContainer.vue?vue&type=script&lang=js&"
export * from "./FormContainer.vue?vue&type=script&lang=js&"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=50fc15b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc15b5",
  null
  
)

export default component.exports